'use client'

import { cva, VariantProps } from 'class-variance-authority'
import { FC, HTMLAttributes } from 'react'

const blockSkeleton = cva('skeleton-pulse w-full rounded-2', {
    variants: {
        height: {
            1: 'h-[50px]',
            2: 'h-[100px]',
            3: 'h-[150px]',
            4: 'h-[200px]',
            5: 'h-[250px]',
            6: 'h-[300px]',
            7: 'h-[350px]',
            8: 'h-[400px]',
            9: 'h-[450px]',
            10: 'h-[500px]'
        }
    },
    defaultVariants: {
        height: 5
    }
})

type BlockSkeletonProps = HTMLAttributes<HTMLDivElement> & VariantProps<typeof blockSkeleton>

const BlockSkeleton: FC<BlockSkeletonProps> = ({ height, className, ...props }) => (
    <div className={blockSkeleton({ height, className })} {...props} />
)

export default BlockSkeleton
